import { render, staticRenderFns } from "./GlobalPanel.vue?vue&type=template&id=4a0e57e8&"
import script from "./GlobalPanel.vue?vue&type=script&lang=js&"
export * from "./GlobalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports